import React, { useState } from "react";
import { Toaster } from "react-hot-toast";
import MainNavigation from "components/navigation/MainNavigation";
import { Outlet } from "react-router-dom";
import {
  DivContent,
  DivFooter,
  DivMain,
  DivNavigation,
} from "./style/layout_common.style";
import FooterBordura from "components/common/view_util/footer/FooterBordura";

export default function MainView() {
  const [menuOpen, setMenuOpen] = useState(false); // kontrola mobilnog menija

  return (
    <>
      <DivMain>
        <DivNavigation>
          <MainNavigation showMenu={menuOpen} setShowMenu={setMenuOpen} />
        </DivNavigation>

        <Toaster />

        {/* Sadržaj koji se pomera kada je meni otvoren */}
        <DivContent pushed={menuOpen}>
          <Outlet />
        </DivContent>

        <DivFooter>
          <FooterBordura />
        </DivFooter>
      </DivMain>
    </>
  );
}
